import { isNullOrUndefined } from '@uzurv/rideWss/app/util';
import { AbstractModel } from './abstract-model';
import { autoserialize, autoserializeAs, inheritSerialization } from 'cerialize';
import { RiderFeeDetail } from './rider-fee-detail';

@inheritSerialization(AbstractModel)
export class RideRequestInfo extends AbstractModel {
  @autoserialize
  rideRequestId: number;

  @autoserializeAs(Date)
  estimatedPickupDate: Date;

  @autoserializeAs(Date)
  estimatedDropoffDate: Date;

  @autoserialize
  tolls: number;

  @autoserialize
  polylineId: number;

  @autoserialize
  polyline: string;

  @autoserialize
  distanceEstimate: number;

  @autoserialize
  durationEstimate: number;

  @autoserialize
  tollEstimate: number;

  @autoserialize
  riderFee: number;

  @autoserializeAs(RiderFeeDetail)
  riderFeeDetail: RiderFeeDetail;

  @autoserialize
  rideBackupEligible: boolean;

  @autoserialize
  errors: Array<string>;

  static OnSerialized(instance: RideRequestInfo, json: any): void {
    super.OnSerialized(instance, json);

    if (!isNullOrUndefined(instance.estimatedPickupDate)) {
      json.estimatedPickupDate = instance.estimatedPickupDate.getTime();
    }

    if (!isNullOrUndefined(instance.estimatedDropoffDate)) {
      json.estimatedDropoffDate = instance.estimatedDropoffDate.getTime();
    }
  }

  static OnDeserialized(instance: RideRequestInfo, json: any): void {
    super.OnDeserialized(instance, json);

    if (!isNullOrUndefined(json['estimatedPickupDate'])) {
      instance.estimatedPickupDate = new Date(json['estimatedPickupDate']);
    }

    if (!isNullOrUndefined(json['estimatedDropoffDate'])) {
      instance.estimatedDropoffDate = new Date(json['estimatedDropoffDate']);
    }
  }
}
